type FormatPercentageValueWithPreviousType = {
  currentValue: number;
  previousValue: number;
  isWithoutFormatting?: boolean;
  decimal?: number;
};

export const formatNumber = (x: number, numberFractionDigits = 2, skipDecimalsForLargeValues = false): string => {
  const noDecimalValue = x % 1 === 0;
  const valueIsOverDecimalDisplayCap = x > 1000;
  const shouldRemoveFractionDigits = noDecimalValue || (valueIsOverDecimalDisplayCap && skipDecimalsForLargeValues);

  const fractionDigits = shouldRemoveFractionDigits ? 0 : numberFractionDigits;

  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: fractionDigits,
    minimumFractionDigits: fractionDigits,
  }).format(x);
};

export const formatToPercentage = (x: number, fractionDigits = 0): string => {
  return `${(x * 100).toFixed(fractionDigits)}%`;
};

export const formatDecimals = (value: number): number => {
  let [int] = value.toString().split('.');
  if (int.length > 2 && parseInt(int) > 100) {
    const divisor = Math.pow(10, int.length - 2);
    value /= divisor;
  }
  return value;
};

export const formatScoreNumber = (value: number, numberFractionDigits: number = 0): number => {
  return !value ? 0 : parseFloat(formatNumber(formatDecimals(value), numberFractionDigits));
};

export const formatNumberWithSpaces = (value: number, separator?: string) => {
  const replaceValue = separator || ' ';
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, replaceValue);
};

export const formatPercentageValueWithPrevious = ({
  currentValue,
  isWithoutFormatting,
  previousValue,
  decimal = 1,
}: FormatPercentageValueWithPreviousType) => {
  const result = previousValue ? ((currentValue - previousValue) * 100) / previousValue : null;
  return isWithoutFormatting ? result : formatNumber(result, decimal);
};

export const calculatePercentage = (currentNumber: number, totalNumber: number) => {
  return currentNumber && totalNumber ? (currentNumber / totalNumber) * 100 : 0;
};

export const roundToTwoDecimals = (value: number): number => Math.round((value + Number.EPSILON) * 100) / 100;
